import React from 'react';
import { FooterLinksContainer } from '@ui/components/molecules/FooterLinksContainer';
import { FooterAccordion } from '@ui/components/molecules/FooterAccordion';
import { LinkedinIcon, TwitterIcon } from '@assets/index';
import FooterNavStyles from './FooterNav.module.scss';

type Props = {
  links: { title: string; titleAr: string; link: string; linkAr: string }[];
};

export const FooterNav: React.FC<Props> = ({ links }) => {
  return (
    <div className={FooterNavStyles.footer_nav}>
      <div className={FooterNavStyles.footer_nav__links}>
        <div className={FooterNavStyles.footer_nav__links_desktop}>
          <FooterLinksContainer links={links} />
        </div>
        <div className={FooterNavStyles.footer_nav__links_responsive}>
          <FooterAccordion>
            <FooterLinksContainer links={links} />
          </FooterAccordion>
        </div>
      </div>
      <div className={FooterNavStyles.footer_nav__social}>
        <a href="https://twitter.com/tawal_ksa?lang=en">
          <TwitterIcon />
        </a>
        <a href="https://www.linkedin.com/company/tawal-ksa">
          <LinkedinIcon />
        </a>
      </div>
    </div>
  );
};
